module.exports = __webpack_public_path__ + "img/drag_icon.d3ce9350.svg";